<template>
  <div
    class="flex justify-items-center items-center bg-cover bg-no-repeat cockpit-header h-100px absolute -top-1px w-full -right-0px"
  >
    <!-- 左侧logo -->
    <div class="flex-1 leading-55px h-full relative flex">
      <img
        v-if="showIf"
        class="ml-20px mt-10px mr-10px w-22rem h-62px cursor-pointer z-1 relative object-contain"
        :src="cockpitLogoUrl"
        alt=""
      />
    </div>
    <!-- <div
      class="text-44px justify-center items-center flex text-[#fff] cockpit-header__mid h-50px relative cursor-pointer w-490px ml-10px"
      @click="changeModule(homeComponent)"
    >
      <span class="leading-100px cursor-pointer truncate">{{ homeComponent.name }}</span>
    </div> -->
    <!-- 右侧操作 -->
    <div
      class="h-full relative flex flex-row items-center justify-between ml-85px cockpit-header__right"
    >
      <div
        class="flex flex-row top-10px self-center"
        :class="[isSubTenantCheck ? 'max-w-750px overflow-hidden' : '']"
      >
        <div
          v-for="item in rightComponents"
          :key="item.id"
          @click="changeModule(item)"
          class="cursor-pointer relative w-171px h-59px bg-cover bg-no-repeat cockpit-header-module"
          :class="
            checkedSection === item.functionLocationType
              ? `cockpit-header-module__right-checked text-[#BBCDE6]`
              : `cockpit-header-module__right text-[#E2EEFF]`
          "
        >
          <span
            class="text-center inline-block w-full font-400 text-18px cockpit-header-module__title leading-59px"
            >{{ item.name }}</span
          >
        </div>
      </div>
      <div
        class="h-100px flex justify-between items-center"
        :class="isSubTenantCheck ? 'w-425px' : 'w-200px'"
      >
        <!-- 新疆制定功能，切换项目（租户） -->
        <el-select
          placeholder="切换租户"
          type="mini"
          clearable
          v-model="currentTenantId"
          @change="selectTenent"
          class="mr-20px !w-200px flex-shrink-0"
          popper-class="visualization-select-popper"
          v-if="isSubTenantCheck"
        >
          <el-option
            :label="item.TenantName"
            :value="item.Id"
            v-for="(item, i) in tenantList"
            :key="i"
          ></el-option>
        </el-select>
        <div
          class="cockpit-header__right-time text-[#BFDFFF] flex flex-col items-start justify-center"
          :class="isSubTenantCheck ? 'mr-10px' : ''"
        >
          <div class="text-14px w-60px">{{ currentTime }}</div>
          <div class="text-12px w-70px">{{ currentDate }}</div>
        </div>
        <div class="pr-4px -left-1px flex flex-1 items-center justify-center">
          <el-tooltip content="报警" placement="top" effect="dark">
            <el-badge
              :max="99"
              :value="alarmNum"
              :hidden="alarmNum <= 0"
              class="alarm-number mr-6px"
            >
              <img
                class="inline-block w-30px h-30px cursor-pointer"
                src="../../assets/images/header/danger-dj.png"
                alt
                @click="$emit('openAlarmList')"
              />
            </el-badge>
          </el-tooltip>
          <!-- <el-tooltip content="智慧览图" placement="top" effect="dark">
            <img
              class="mr-10px inline-block w-30px h-30px cursor-pointer"
              :src="require(`../../assets/images/header/header_menu${imgIndex}.png`)"
              alt=""
              @click="changeModule('smart-map')"
            />
          </el-tooltip> -->
          <el-tooltip content="管理台" placement="top" effect="dark">
            <img
              class="inline-block w-30px h-30px cursor-pointer mx-6px"
              src="../../assets/images/header/home-dj.png"
              alt=""
              @click="toHomePage()"
            />
          </el-tooltip>
          <el-tooltip
            content="切换至驾驶舱"
            placement="top"
            effect="dark"
            v-if="mode === 'visualization' && !hiddenSwitchButton"
          >
            <img
              class="inline-block w-30px h-30px cursor-pointer ml-6px"
              src="../../assets/images/header/retract-dj.png"
              alt=""
              @click="toggleMode('cockpit')"
            />
          </el-tooltip>
          <el-tooltip
            content="切换至可视化"
            placement="top"
            effect="dark"
            v-if="mode === 'cockpit' && !hiddenSwitchButton"
          >
            <img
              class="inline-block w-30px h-30px cursor-pointer ml-6px"
              src="../../assets/images/header/retract-dj.png"
              alt=""
              @click="toggleMode('visualization')"
            />
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  SectionApi,
  SchemeApi,
  ThreeDimensionalAlarmCenterApi,
} from '@wiz-api/cloud-render-management'
import { eq, assign } from 'lodash'
import { FileApi } from '@wiz-api/file-management'
import projectNavigationTenant from '../../service/ProjectNavigationTenant'

const fileApi = new FileApi()
const sectionApi = new SectionApi()
const schemeApi = new SchemeApi()
const alarmCenterApi = new ThreeDimensionalAlarmCenterApi()

export default {
  name: 'CockpitHeaderDj',
  props: {
    hiddenSwitchButton: {
      type: Boolean,
      defalut: false,
    },
    defaultSection: {
      type: String,
      default: '',
    },
    alarmJumpSection: {
      type: Object,
      default: () => {},
    },
    loadModelStatus: {
      type: Boolean,
      default: false,
    },
    showIf: {
      type: Boolean,
      default: true,
    },
    isSubTenantCheck: {
      type: Boolean,
      default: false,
    },
    previewSchemeId: {
      type: String,
      default: null,
    },
    previewLogo: {
      type: String,
      default: null,
    },
  },
  watch: {
    defaultSection(val) {
      this.setDefalutSection()
    },
    alarmJumpSection(val) {
      this.changeModule(val)
    },
  },
  data() {
    return {
      imgIndex: 0,
      // 当前租户
      currentTenantId: '',
      // 租户列表
      tenantList: [],
      rightComponents: [],
      homeComponent: {},
      // 当前选中的板块
      checkedSection: '',
      // 默认激活的模式
      mode: 'cockpit',
      totalComponents: [],
      cockpitLogoUrl: '',
      currentTime: null,
      currentDate: null,
      alarmNum: 0, // 当日报警数
      getAlarmTimer: null, // 获取当日报警定时器标识
    }
  },
  computed: {
    defaultHomePage() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit-tongre"].config')
          ?.defaultHomePage || ''
      )
    },
  },
  async created() {
    if (this.$route.query.mode) {
      this.toggleMode(this.$route.query.mode)
    }
    // 低代码子租户
    this.getTenantList()
    // 获取板块列表
    await this.getSectionList()
    // 获取当日报警总数
    this.getTodayAlarmNum()
    this.getAlarmTimer = setInterval(() => {
      this.getTodayAlarmNum()
    }, 15000)
    // 默认加载
    this.setDefalutSection()
  },
  mounted() {
    this.getCurrenTime()
    setInterval(() => {
      this.getCurrenTime()
    }, 1000)
  },
  methods: {
    getCurrenTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = (now.getMonth() + 1).toString().padStart(2, '0')
      const day = now.getDate().toString().padStart(2, '0')
      const hour = now.getHours().toString().padStart(2, '0')
      const minute = now.getMinutes().toString().padStart(2, '0')
      const second = now.getSeconds().toString().padStart(2, '0')
      this.currentTime = `${hour}:${minute}:${second}`
      this.currentDate = `${year}.${month}.${day}`
    },
    setDefalutSection() {
      const currentItem = _.find(this.totalComponents, [
        'functionLocationType',
        Number(this.defaultSection),
      ])
      if (currentItem) {
        this.changeModule(currentItem, true)
      }
    },
    // 获取logo图片
    async getLogoContent(id) {
      const [fileErr, fileRes] = await fileApi.getFileContent(id)
      if (!fileErr) {
        this.cockpitLogoUrl = `data:image/jpg;base64,${fileRes.content}`
      }
    },
    /**
     * @description: 获取模块列表
     * @return {*}
     */

    async getSectionList() {
      // 获取当前用户加载方案
      const keyword = _.get(this.$route, 'query.programmeCode')
      console.log('获取当前用户方案keyword', keyword)
      // 未匹配当前用户设置方案，使用默认方案
      const params = _.omit(
        {
          keyword,
          isEnable: true,
          maxResultCount: 1,
          skipCount: 0,
        },
        keyword ? 'isEnable' : 'name'
      )
      console.log('获取方案详情参数', params)
      let errScheme
      let resScheme
      if (this.previewSchemeId) {
        // 通过方案管理过来
        resScheme = {
          items: [
            {
              id: this.previewSchemeId,
              logo: this.previewLogo,
            },
          ],
        }
        // previewLogo
      } else {
        ;[errScheme, resScheme] = await schemeApi.getList(params)
      }
      console.log('获取方案详情', resScheme)
      const currentProgrammeId = _.get(_.head(resScheme.items), 'id')
      // 不存在匹配项，跳出模块获取
      if (!currentProgrammeId) {
        return
      }
      if (_.get(_.head(resScheme.items), 'logo')) {
        this.getLogoContent(_.get(_.head(resScheme.items), 'logo'))
      }
      const [err, res] = await sectionApi.getList({ schemeId: currentProgrammeId })
      if (!err && res && res.items) {
        this.totalComponents = res.items
        _.forEach(res.items, (item) => {
          if (item.functionLocationType === 5) {
            this.homeComponent = item
          } else {
            this.rightComponents.push(item)
          }
        })
        this.rightComponents = _.sortBy(this.rightComponents, 'functionLocationType')
      }
    },
    changeModule(moduleItem, defalut = false) {
      localStorage.setItem('sceneId', moduleItem.sceneId)
      if (moduleItem === 'smart-map') {
        this.$router.push('/cockpit-hz/cockpit-index/smart-map')
        this.imgIndex = 1
        this.checkedSection = ''
        return
      }
      // if (!this.loadModelStatus && !defalut) {
      //   this.$message.warning('模型加载中，请稍后...')
      //   return
      // }
      if (moduleItem) {
        this.imgIndex = 0
        this.checkedSection = moduleItem.functionLocationType
        this.$emit('changeModule', moduleItem)
      }
    },
    toggleMode(mode) {
      this.mode = mode
      this.$emit('toggleMode', mode)
    },
    /**
     * 回到主页
     */
    toHomePage() {
      // 如果是微前端模式，则返回低代码-我的工作页面
      if (window.__POWERED_BY_QIANKUN__) {
        // Wiz.router.push('/my-work')
        Wiz.router.push(this.defaultHomePage || '/my-work')
        return
      }
      this.$router.push(this.defaultHomePage || '/system-management/personal-center')
      // const defaultPath = this.$store.getters['Auth/defaultPath']
      // const menuList = this.$store.getters['Auth/menuList']
      // // 过滤掉驾驶舱页面
      // if (defaultPath && !defaultPath.startsWith('/cockpit')) {
      //   this.$router.push(defaultPath)
      // } else if (_.isEmpty(menuList)) {
      //   this.$router.push('/')
      // } else {
      //   // 跳转至第一个模块
      //   const path = this.getFirstPage(menuList)
      //   this.$router.push(path || '/')
      // }
    },
    getFirstPage(menuList) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < menuList.length; i++) {
        const menuItem = menuList[i]
        let path = null
        if (menuItem.children && menuItem.children.length) {
          path = this.getFirstPage(menuItem.children)
        } else {
          path = menuItem.index
        }
        // 模块不为第三方地址时跳转且不为驾驶舱页面
        if (path && path.startsWith('/') && !path.startsWith('/cockpit')) {
          return path
        }
      }
      return null
    },
    // 获取当日报警总数
    async getTodayAlarmNum() {
      const [err, res] = await alarmCenterApi.getToDayAlarmCount()
      if (!err && !_.isNil(res)) {
        this.alarmNum = res
      }
    },
    // 获取租户列表
    async getTenantList() {
      if (!this.isSubTenantCheck) {
        return
      }
      // 监听租户切换成功刷新方案板块数据
      this.toggleTenantIdChangeSuccess()
      this.currentTenantId =
        localStorage.getItem('CurrentTenantId') ||
        JSON.parse(localStorage.getItem('CurrentUser'))?.TenantId ||
        'saas'
      const [err, res] = await projectNavigationTenant.getTenantList({
        isRecursion: true,
        pageIndex: 1,
        pageSize: 999,
      })
      if (res && res.Code === 1) {
        const CompanyName = localStorage.getItem('itdos.ClientCompany')
        this.tenantList = [
          {
            TenantName: CompanyName || '',
            Id: 'saas',
          },
          ...res.Data,
        ]
      }
    },
    toggleTenantIdChangeSuccess(open = true) {
      if (!this.isSubTenantCheck) {
        return
      }
      if (!open) {
        window.removeEventListener('RefreshCockpitData', this.tenantChangeSuccess)
        return
      }
      window.addEventListener('RefreshCockpitData', this.tenantChangeSuccess)
    },
    async tenantChangeSuccess(e) {
      if (!eq(e.type, 'RefreshCockpitData')) {
        return
      }
      // 临时方案 不刷新页面更新缓存数据
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      const accessToken = localStorage.getItem('authorization')
      Wiz.AuthHooks.SetUserInfo(
        assign(userInfo, {
          access_token: accessToken,
        })
      )
      // 初始板块数据
      this.totalComponents = this.$options.data().totalComponents
      this.homeComponent = this.$options.data().homeComponent
      this.rightComponents = this.$options.data().rightComponents
      // 获取板块列表
      await this.getSectionList()
    },
    // 切换租户（新疆定制）
    selectTenent() {
      if (this.currentTenantId) {
        // 是否切换至子租户
        this.$confirm(`${this.$t('此操作将切换至该项目，是否继续？')}`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          // 低代码监听租户变化
          localStorage.setItem('CurrentTenantId', this.currentTenantId)
          window.dispatchEvent(new Event('CurrentTenantIdStorage'), {
            key: 'CurrentTenantId',
          })
        })
      }
    },
  },
  beforeDestroy() {
    this.toggleTenantIdChangeSuccess(false)
    // 清除获取报警总数的定时器
    if (this.getAlarmTimer) {
      clearInterval(this.getAlarmTimer)
    }
  },
}
</script>

<style lang="scss" scoped>
.cockpit-header {
  background: url('../../assets/images/header/titlebgdj.png');
  background-size: 100% 202%;

  &__mid {
    font-family: PangMenZhengDaoTitleBody;
  }

  &__right {
    width: calc(100% - 700px);

    &-time {
      font-family: PangMenZhengDaoTitleBody;
    }
  }

  &-module {
    &__title {
      line-height: 59px !important;
    }

    &__right {
      // background-image: url('../../assets/images/header/top_button_default.png');
      // background-size: 100% 100%;

      &-checked {
        background-image: url('../../assets/images/header/top_button_active_dj.png');
        background-size: 100% 100%;
      }
    }
  }
}

.alarm-number {
  ::v-deep .el-badge__content.is-fixed {
    right: 30px;
  }
}
</style>
